import Vue from 'vue'
import Vuex from 'vuex'
import scorm from '@shared/utils/scormHandler'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stepIndex: 0,
    steps: ['intro', 'infography', 'quizz', 'outro'],
    quizzScore: 0
  },
  getters: {
    currentStep (state) {
      return state.steps[state.stepIndex]
    },
    progress (state) {
      return state.stepIndex / (state.steps.length - 1) * 100
    },
    status (state, getters) {
      return getters.progress === 100 ? 'passed' : 'incomplete'
    },
    quizzStatus (state) {
      if (state.quizzScore >= 7) {
        return 'success'
      } else if (state.quizzScore >= 5) {
        return 'normal'
      } else {
        return 'fail'
      }
    }
  },
  mutations: {
    loadState (state, datas) {
      state.stepIndex = datas.stepIndex
      state.quizzScore = datas.quizzScore
    },
    nextStep (state) {
      state.stepIndex++
    },
    navigateTo (state, index) {
      state.stepIndex = index
    },
    setQuizzScore (state, score) {
      state.quizzScore = score
    }
  },
  actions: {
    next ({ state, dispatch, commit }) {
      if (state.stepIndex === state.steps.length - 1) {
        dispatch('exit')
      } else {
        commit('nextStep')
      }
    },
    navigate ({ state, commit }, stepName) {
      commit('navigateTo', state.steps.indexOf(stepName))
    },
    init ({ dispatch }) {
      scorm.initLMSConnection()
      dispatch('load')
    },
    save ({ state, getters }) {
      scorm.setDatasToLMS({
        stepIndex: state.stepIndex,
        score: state.quizzScore
      })
      scorm.writeProgressToLMS(getters.progress, getters.status)
      try {
        scorm.commitToLMS()
      } catch (e) {
        if (process.env.NODE_ENV === 'production') {
          console.log('SCORM api error : ' + e)
        }
      }
    },
    load ({ commit }) {
      if (scorm.getDatasFromLMS()) {
        commit('loadState', scorm.getDatasFromLMS())
      }
    },
    exit ({ dispatch }) {
      dispatch('save')
      scorm.exitLMSConnection()
    }
  }
})
